// eslint-disable-next-line @atlassian/tangerine/import/entry-points

export function createToken(state, type, level) {
  var nesting;
  if (type.includes('_open')) {
    nesting = 1;
  } else if (type.includes('_close')) {
    nesting = -1;
  } else {
    nesting = 0;
  }
  var token = new state.Token(type, '', nesting);
  if (level) {
    token.level = level;
  }
  return token;
}